module.exports = __webpack_public_path__ + "static/media/profile.2bdcd6b5.svg";